import { FC, useState } from "react"
import { Alert, Input, Space } from "antd"
import { ParsedRecordingIds, invalidIdsMessage, parseRecordingIds } from "../utils"

export const RecordingIdsInput: FC<{
  max?: number
  placeholder: string
  onChange: (parsed: ParsedRecordingIds) => void
}> = ({ max, placeholder, onChange }) => {
  const [parsed, setParsed] = useState<ParsedRecordingIds>({ ids: [], invalid: [] })

  const onTextChange = (text: string) => {
    const next = parseRecordingIds(text)
    setParsed(next)
    onChange(next)
  }

  return (
    <Space direction="vertical" style={{ width: "100%" }}>
      <Input.TextArea rows={3} placeholder={placeholder} onChange={e => onTextChange(e.target.value)} />
      {parsed.invalid.length > 0 && (
        <Alert type="warning" showIcon message={invalidIdsMessage(parsed.invalid)} />
      )}
      {max !== undefined && parsed.ids.length > max && (
        <Alert type="error" showIcon message={`${parsed.ids.length} ids — at most ${max} at a time.`} />
      )}
    </Space>
  )
}
